module.exports = __webpack_public_path__ + "./images/p22.JPG?6feb5170d0a7aa976fe79b0eea7ec1a9";


//////////////////
// WEBPACK FOOTER
// ./src/products/p22.JPG
// module id = 58
// module chunks = 0